<template>
  <div class="container-vs-pods-main-container bg-themeComponentBg-light font-rubik">
    
    <div class="w-full flex justify-center item-center">
      <div class="w-full max-w-1024 flex flex-col justify-start items-start">
        <h2 class="main-h">Containers vs Pods®</h2>
        <p class="main-txt">
          Container Alliance provides heavy duty shipping containers for sale or rent that are also great
          for portable storage applications. There are some substantial differences between Pods®
          that are intended for moving and storage.
        </p>
      </div>
    </div>

    <div class="w-full hidden lg:flex justify-center item-center">
      <table class="max-w-1024 w-full border-separate border-spacing-0 table-auto [&_td]:!border-[#EDE9E3]">
        <thead>
          <tr>
            <th/>
            <th
              class="column-title text-[1rem] leading-[2rem] bg-[#EDE9E3] border-[#D4CBBF] border !font-medium rounded-t-lg"
            >
              <p class="px-5 py-4">Pods®</p>
            </th>
            <th/>
            <th
              class="column-title border-[#D4CBBF] border rounded-t-lg bg-white-important"
            >
              <p class="px-5 py-4">Containers</p>
              <div class="w-full flex justify-center mt-[25px]">
                <button class="get-quote-button flex items-center justify-center"
                  data-vue-init="lead-flow" data-props='{ "gtag": "get_quote"}'
                >
                  <p>Get started</p>
                </button>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in containerVsPods"
            :key="item.name"
            class="[&_td]:!p-2 [&_td]:text-[1rem] [&_td]:leading-[1.5rem]"
          >
            <td
              class="row-title"
              :class="[{ 'no-border' : (index == 0) }]"
            >
              {{ item.name }}
            </td>
            <td
              class="w-full flex justify-center items-center bg-[#EDE9E3]"
              style="border: 1px solid #D4CBBF !important"
            >
              <img v-if="item.pods" src="@/images/containers-vs-pods/true.png" alt="">
              <img v-else src="@/images/containers-vs-pods/false.png" alt="">
            </td>
            <td class="!p-0 border border-[#D4CBBF]"/>
            <td
              class="w-full flex justify-center items-center border border-[#D4CBBF] bg-white"
            >
              <img v-if="item.containers" src="@/images/containers-vs-pods/true.png" alt="">
              <img v-else src="@/images/containers-vs-pods/false.png" alt="">
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="w-full lg:hidden flex justify-center item-center mobile-table-container">
      <div class="w-full" >
        <div class="w-full flex flex-row h-[180px]">
          <div class="bg-[#EDE9E3] p-5 border-tl-rounded border border-[#D4CBBF]">
            <p class="mobile-table-h">Pods®</p>
          </div>
          <div class="bg-white p-5 border-tr-rounded border border-[#D4CBBF]">
            <p class="mobile-table-h">Containers</p>
            <div class="w-full flex justify-center mt-[30px]">
              <button class="get-quote-button flex items-center justify-center"
                data-vue-init="lead-flow" data-props='{ "gtag": "get_quote"}'
              >
                <p>Get started</p>
              </button>
            </div>
          </div>
        </div>

        <div 
          v-for="(item, index) in containerVsPods"
          :key="item.name"
          class="w-full flex flex-col"
        >
          <div class="w-full flex flex-col justify-center pl-4 mobile-item-name">
            <p>{{ item.name }}</p>
          </div>

          <div class="w-full flex h-56px">
            <div
              class="w-full flex justify-center items-center bg-[#EDE9E3] border border-[#D4CBBF]"
              :class="[{ 'border-bl-rounded' : (containerVsPods.length == index+1) }]"
            >
              <img v-if="item.pods" src="@/images/containers-vs-pods/true.png" alt="">
              <img v-else src="@/images/containers-vs-pods/false.png" alt="">
            </div>

            <div
              class="w-full flex justify-center items-center bg-white border border-[#D4CBBF]"
              :class="[{ 'border-br-rounded' : (containerVsPods.length == index+1) }]"
            >
              <img v-if="item.containers" src="@/images/containers-vs-pods/true.png" alt="">
              <img v-else src="@/images/containers-vs-pods/false.png" alt="">
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContainerVsPods',
  data() {
    return {
      containerVsPods: [
        {
          name: 'Double gasket on cargo doors',
          pods: false,
          containers: true
        },
        {
          name: 'Durable and tough for construction applications',
          pods: false,
          containers: true
        },
        {
          name: 'Water and rodent proof',
          pods: false,
          containers: true
        }, 
        {
          name: 'High security with multiple locking points',
          pods: false,
          containers: true
        }, 
        {
          name: 'Capable of off-road delivery',
          pods: false,
          containers: true
        },
        {
          name: '100% steel exterior frame, roof and sidewalls',
          pods: false,
          containers: true
        },
        {
          name: 'Available in both cargo and roll-up doors',
          pods: false,
          containers: true
        },
        {
          name: 'Customizable',
          pods: false,
          containers: true
        },
        {
          name: 'Delivery to your location',
          pods: true,
          containers: true
        },
        {
          name: 'Lockable',
          pods: true,
          containers: true
        },
        
        {
          name: 'Able to store at Pods® facility',
          pods: true,
          containers: false
        }
      ]
    }
  },
  //improve search engine optimization
  mounted() {
    try {
      const ld = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        'headline': document.querySelector('.main-h')?.innerText || document.title,
        'description': document.querySelector('.main-txt')?.innerText || '',
        'url': window.location.href,
        'publisher': {
          '@type': 'Organization',
          'name': 'Container Alliance'
        }
      }
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.text = JSON.stringify(ld)
      document.head.appendChild(script)
    } catch (e) {
      console.warn('Error injecting JSON-LD:', e)
    }
  }
}
</script>

<style scoped>

.container-vs-pods-main-container {
  padding-top: 112px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 80px;
}
.main-h {
  font-size: 48px;
  font-weight: 400;
  line-height: 57.6px;
  letter-spacing: -0.04em;
  color: #334155;
  margin-bottom: 32px;
}
.main-txt {
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: -0.02em;
  color: #334155;
}
.column-title {
  height: 190px;
  width: 297px;
}
.column-title p {
  font-size: 32px;
  font-weight: 400;
  line-height: 41.6px;
  letter-spacing: -0.04em;
  color: #334155;
}
.row-title {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #334155;
  border-top: 1px solid #D4CBBF !important;
  border-bottom: 1px solid #D4CBBF !important;
}
.get-quote-button {
  width: 248px;
  height: 44px;
  background-color: #3565FC;
  border: 1px solid #90B6FF;
  border-radius: 99px;
}

.get-quote-button p {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.04em;
  color: #FFF;
}
.no-border {
  border: none !important;
}
.mobile-table-container {
  margin-top: 64px;
  border: 1px solid #D4CBBF !important;
  border-radius: 16px;
}

.mobile-table-h {
  font-size: 24px;
  font-weight: 400;
  line-height: 33.6px;
  letter-spacing: -0.04em;
  color: #334155;
}

.mobile-item-name {
  height: 52px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  letter-spacing: -0.02em;
  color: #334155;
  border: 1px solid #D4CBBF
}

.border-bl-rounded {
  border-bottom-left-radius: 16px;
}

.border-br-rounded {
  border-bottom-right-radius: 16px;
}

.border-tl-rounded {
  width: 50%;
  border-top-left-radius: 16px;
}

.border-tr-rounded {
  width: 50%;
  border-top-right-radius: 16px;
}

.bg-white-important {
  background: white !important;
}

.h-202px {
  height: 202px;
}

.mt-70px {
  margin-top: 70px;
}

.h-56px {
  height: 56px;
}

/* mobile */
@media(max-width: 1024px) {
  .container-vs-pods-main-container {
    gap: 0px;
    padding-top: 64px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .main-h {
    font-size: 36px;
    font-weight: 400;
    line-height: 43.2px;
    letter-spacing: -0.04em;
    color: #334155;
    margin-bottom: 32px;
  }
  .main-txt {
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    letter-spacing: -0.02em;
    color: #334155;
  }
  .get-quote-button {
    width: 135px;
    height: 44px;
    background-color: #3565FC;
    border: 1px solid #90B6FF;
    border-radius: 99px;
  }

  .get-quote-button p {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.04em;
    color: #FFF;
  }
}

</style>
